import { createSlice } from "@reduxjs/toolkit"

const orderSlice = createSlice({
    name: "orders",
    initialState: {
        orders: [],
        isFetching: false,
        error: null
    },
    reducers: {
        orderStart: (state) => {
            state.isFetching = true
        },
        orderFailure: (state, action) => {
            state.orders = []
            state.isFetching = false
            state.error = action.payload
        },
        getOrderSuccess: (state, action) => {
            state.orders = action.payload
            state.isFetching = false
            state.error = null
        },
        updateOrderSuccess: (state, action) => {
            state.orders[state.orders.findIndex((item) => item._id === action.payload.id)] = action.payload.order
            state.isFetching = false
            state.error = null
        },
        deleteOrderSuccess: (state, action) => {
            state.orders.splice(
                state.orders.findIndex((item) => item._id === action.payload),
                1
            )
            state.isFetching = false
            state.error = null
        }
    }
})

export const {
    orderStart,
    orderFailure,
    getOrderSuccess,
    updateOrderSuccess,
    deleteOrderSuccess
} = orderSlice.actions

export default orderSlice.reducer